/** @jsxImportSource @emotion/react */
import React from "react";
import styled from "@emotion/styled";
import { ReactComponent as ResetIcon } from "../../../../../img/butter_svgs/Reset.svg";
import { GlobalStore, INITIAL_STATE } from "../../../../../store/global/GlobalStore";
import { useSelectedNetworkConfig } from "../../../../../hooks/useSelectedNetworkConfig";
import { resetApprovalState } from "../../../../../store/approvals/ApprovalsStore";
import { OrderStatus } from "../../../../../types/orderStatus";

export const ApprovalsHeader: React.FC = () => {
  const network = GlobalStore.useState(s => s.network);
  const theme = GlobalStore.useState(s => s.theme);
  const SelectedNetworkIcon = useSelectedNetworkConfig(network.id)?.icon;
  return (
    <ApprovalsHeaderContainer>
      <div>
        <ResetIcon
          style={{ cursor: "pointer", color: theme.button.primary.surface.active }}
          onClick={() => {
            resetApprovalState();
            GlobalStore.update(s => {
              s.orderStatus = OrderStatus.ENTRY;
              s.permits = INITIAL_STATE.permits;
            });
          }}
        />
      </div>
      <div>
        <SelectedNetworkIcon />
      </div>
    </ApprovalsHeaderContainer>
  );
};

export const ApprovalsHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 26px;
  padding-right: 26px;
  width: 100%;
`;
